<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  fontClamp?: {
    min: number;
    size: number;
    max: number;
  };
}

const props = withDefaults(defineProps<Props>(), {
  fontClamp: () => ({
    min: 0.75,
    size: 3.5,
    max: 3.5,
  }),
});

const fontSize = computed(
  () =>
    `clamp(${props.fontClamp.min}rem, ${props.fontClamp.size}vw, ${props.fontClamp.max}rem)`,
);
// defineEmits<{
//   // (event: 'update:modelValue', payload: string): void
// }>()
</script>

<template>
  <q-banner>
    <div class="text-home-title q-my-none text-uppercase">
      <slot class="">
        {{ $t('FROM') }} <strong>{{ $t('FLASH_SCHOOL_OF_ENGLISH') }}</strong>
      </slot>
    </div>

    <template #action> </template>
  </q-banner>
</template>

<style scoped lang="scss">
.text-home-title {
  font-size: v-bind(fontSize);
}
</style>
